import { gql } from '@/features/graphql/generated'

export const ContainersQuery = gql(/* GraphQL */ `
    query Containers {
        containers {
            ...CatalogContainer
        }
    }
`)
